/** Keep navigation inside the thread, including when embedded in the design page. */
export function scrollConversationTo(element: Element | null | undefined) {
  const thread = element?.closest('main')
  if (!element || !thread) return
  thread.scrollTo({ top: thread.scrollTop + element.getBoundingClientRect().top - thread.getBoundingClientRect().top - 24, behavior: 'instant' })
}
